import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {PointOfSaleEditComponent} from "./edit/point-of-sale-edit.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:id/pointsOfSale', {template: ''})
            .when('/company/:companyId/pointsOfSale/:id', {template: ''});
    }]);
/***/

const pointOfSaleRoutes: Routes = [
    {path: 'company/:companyId/pointsOfSale/:id', component: PointOfSaleEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/pointsOfSale/:id', component: PointOfSaleEditComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(pointOfSaleRoutes)
    ],
    exports: [
        RouterModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PointOfSaleRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/point-of-sale-routing.module.ts